import { fetchJson } from './request'

export default class TokenStorage {
  constructor(config) {
    this.token = false
    this.config = config
  }
  setConfig(config) {
    this.config = config
  }
  refreshToken() {
    return fetchJson(this.config.url, this.config.options).then(responseContent => {
      const token = responseContent.access_token
      this.setToken(token)
      return token
    })
  }
  setToken(token) {
    this.token = token
  }
  getToken() {
    return this.token
  }
}
